import {useEffect} from 'react';
import {api,orgPath} from './api';

/** Report recent foreground interaction, not merely an unexpired login. */
export function useActivityHeartbeat(organizationId:string|undefined){
 useEffect(()=>{
  if(!organizationId)return;
  let lastInteraction=Date.now(),lastSent=0;
  const ping=()=>{
   const now=Date.now();
   if(document.visibilityState!=='visible'||!document.hasFocus()||now-lastInteraction>60_000||now-lastSent<45_000)return;
   lastSent=now;
   void api(orgPath(organizationId,'activity'),{method:'POST'}).catch(()=>{/* Presence is optional; never interrupt work. */});
  };
  const activity=()=>{lastInteraction=Date.now();ping();};
  const visible=()=>{if(document.visibilityState==='visible'&&document.hasFocus())activity();};
  const events=['pointerdown','keydown','wheel','touchstart'] as const;
  for(const event of events)window.addEventListener(event,activity,{passive:true});
  window.addEventListener('focus',activity);
  document.addEventListener('visibilitychange',visible);
  ping();const timer=window.setInterval(ping,30_000);
  return()=>{window.clearInterval(timer);for(const event of events)window.removeEventListener(event,activity);window.removeEventListener('focus',activity);document.removeEventListener('visibilitychange',visible);};
 },[organizationId]);
}
